/* eslint-disable */
/**
 * TODO: make code linter compatible
 */
import { ForbiddenException } from '@/lib/exceptions/ForbiddenException'
import { NotFoundException } from '@/lib/exceptions/NotFoundException'
import { SerializationHelper } from '@/lib/utils/SerializationHelper'
import { UnknownServerErrorException } from '../exceptions/UnknownServerErrorException'
import { StringUtils } from '../utils/StringUtils'
import { ISubClass } from '../utils/ISubClass'
import { Http } from '@/lib/utils/Http'

export abstract class AbstractModel {
  protected static readonly apiBase = '/api'
  public id: number|null = null

  public static async getAll<T extends AbstractModel> (this: new() => T, {params, subclasses}: { params?: Array<string | number>, subclasses?: ISubClass[] }): Promise<any> {
    const classPath =  this.hasOwnProperty('classPath') ? 
      (this as any).classPath :
      StringUtils.toKebabCase(this.name.split('_')[0])

    let uriParams = ''
    if (params && params.length) {
      params.forEach(param => {
        uriParams += "/" + param;
      });
    }

    const res = await Http.request(AbstractModel.apiBase + '/' + classPath + uriParams)
    switch (res.status) {
      case 403:
        throw new ForbiddenException()
      case 404:
        throw new NotFoundException()
    }
    const resData = await res.json()
    const instances = SerializationHelper.toInstanceArray(this, resData)


    if (subclasses) { 
      instances.map(primaryInstance => {
        // map subclasses
        subclasses.forEach(subclass => {
          if (primaryInstance[subclass.subclassPath]) {
            if (Array.isArray(primaryInstance[subclass.subclassPath])) {
              primaryInstance[subclass.subclassPath] = SerializationHelper.toInstanceArray(subclass.subclassInstance,primaryInstance[subclass.subclassPath])
            } else {
              primaryInstance[subclass.subclassPath] = SerializationHelper.toInstance(new subclass.subclassInstance(), primaryInstance[subclass.subclassPath])
            }
          }
        })
      })
    }
    return instances
  }

  public static async get<T extends AbstractModel> (this: new() => T, id: string | number, subclasses: ISubClass[] = []): Promise<T> {
    const classPath = StringUtils.toKebabCase(this.name.split('_')[0])
    const res = await Http.request(AbstractModel.apiBase + '/' + classPath + '/' + id)
    switch (res.status) {
      case 403:
        throw new ForbiddenException()
      case 404:
        throw new NotFoundException()
    }

    const resData = await res.json()

    const primaryInstance = SerializationHelper.toInstance(new this(), resData)

    // map subclasses
    subclasses.forEach(subclass => {
      if (Array.isArray(primaryInstance[subclass.subclassPath])) {
        primaryInstance[subclass.subclassPath] = SerializationHelper.toInstanceArray(subclass.subclassInstance, primaryInstance[subclass.subclassPath])
      } else {
        primaryInstance[subclass.subclassPath] = SerializationHelper.toInstance(new subclass.subclassInstance(), primaryInstance[subclass.subclassPath])
      }
    })
    return primaryInstance
  }

  public static async delete (id: string | number): Promise<unknown> {
    const classPath = StringUtils.toKebabCase(this.name.split('_')[0])
    const res = await Http.request(this.apiBase + '/' + classPath+ '/' + id, {
      method: 'DELETE'
    })
    switch (res.status) {
      case 403:
        throw new ForbiddenException()
      case 404:
        throw new NotFoundException()
    }

    return res.json()
  }

  public async create({params}: { params?: Array<string | number>} = {}): Promise<any> {
    const classPath =  this.constructor.hasOwnProperty('classPath') ? 
      (this as any).constructor.classPath :
      StringUtils.toKebabCase(this.constructor.name.split('_')[0])


    let uriParams = ''
      if (params && params.length) {
        params.forEach(param => {
          uriParams += "/" + param;
        });
      }

    const res = await Http.request(AbstractModel.apiBase + '/' + classPath + uriParams, {
      method: 'POST',
      body: JSON.stringify(this),
      headers: {
        'Content-Type': 'application/json'
      }
    })

    switch (res.status) {
      case 403:
        throw new ForbiddenException()
      case 404:
        throw new NotFoundException()
    }

    const resData = await res.json()

    Object.getOwnPropertyNames(this).forEach(propName => {
      if (resData.hasOwnProperty(propName)) {
        (this as any)[propName] = resData[propName]
      }
    })

    if (resData.status === 'success') {
      return resData
    }
    return false
  }

  public async update (): Promise<boolean> {
    const classPath = StringUtils.toKebabCase(this.constructor.name.split('_')[0])
    const res = await Http.request(AbstractModel.apiBase + '/' + classPath + '/' + this.id, {
      method: 'PUT',
      body: JSON.stringify(this),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    switch (res.status) {
      case 403:
        throw new ForbiddenException()
      case 404:
        throw new NotFoundException()
      case 500:
        throw new UnknownServerErrorException()
    }

    return true
  }
}
